import NoImage from "../../assets/images/No_Image_Available.jpg";
import LazyImage from "../image/LazyLoadImage";
import { motion } from "framer-motion";
import { Calendar, Award } from "lucide-react";


const ProgrammeComponent = ({program}) => {
  return (
    <motion.div
      whileHover={{ y: -8 }}
      className="w-full relative h-full bg-white rounded-2xl overflow-hidden border-2 border-mamba-golden/20 hover:border-mamba-golden shadow-lg hover:shadow-2xl transition-all group cursor-pointer"
    >
      {/* Image Section */}
      <div className="relative h-[280px] overflow-hidden">
        <motion.img
          whileHover={{ scale: 1.1 }}
          transition={{ duration: 0.6 }}
          src={program?.display_image_url ?? NoImage}
          alt={program?.name || "Programme"}
          className="w-full h-full object-cover"
        />
        
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-mamba-navy/60 via-transparent to-transparent" />
        
        {/* Programme Badge */}
        <div className="absolute top-4 left-4">
          <div className="px-3 py-1.5 rounded-full bg-gradient-to-r from-mamba-golden to-amber-400 flex items-center gap-2 shadow-lg">
            <Award className="text-white" size={16} />
            <span className="text-xs font-bold font-montserrat text-white uppercase">
              Training Program
            </span>
          </div>
        </div>
      </div>

      {/* Content Section */}
      <div className="p-5">
        {/* Title */}
        <h3 className="font-bold font-montserrat text-lg text-mamba-navy mb-3 line-clamp-2 group-hover:text-mamba-golden transition-colors">
          {program?.name}
        </h3>

        {/* Date Range */}
        <div className="space-y-2">
          <div className="flex items-center gap-2 text-sm">
            <Calendar className="w-4 h-4 text-mamba-sky-blue flex-shrink-0" />
            <span className="text-xs font-semibold font-montserrat text-slate-500 uppercase">Start:</span>
            <span className="text-sm font-semibold font-inter text-mamba-navy">
              {new Date(program?.start_date).toLocaleDateString("en-US", {
                year: "numeric",
                month: "short",
                day: "2-digit",
              })}
            </span>
          </div>
          <div className="flex items-center gap-2 text-sm">
            <Calendar className="w-4 h-4 text-mamba-golden flex-shrink-0" />
            <span className="text-xs font-semibold font-montserrat text-slate-500 uppercase">End:</span>
            <span className="text-sm font-semibold font-inter text-mamba-navy">
              {new Date(program?.end_date).toLocaleDateString("en-US", {
                year: "numeric",
                month: "short",
                day: "2-digit",
              })}
            </span>
          </div>
        </div>
      </div>

      {/* Hover Effect Border */}
      <div className="absolute inset-0 rounded-2xl ring-2 ring-mamba-golden ring-opacity-0 group-hover:ring-opacity-100 transition-all duration-300 pointer-events-none" />
    </motion.div>
  );
};

export default ProgrammeComponent;
